var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project.id)?_c('Project',{attrs:{"project":_vm.project}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }